import { render, staticRenderFns } from "./addcurrencyMapping.vue?vue&type=template&id=e60f1154&scoped=true&"
import script from "./addcurrencyMapping.vue?vue&type=script&lang=js&"
export * from "./addcurrencyMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60f1154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e60f1154')) {
      api.createRecord('e60f1154', component.options)
    } else {
      api.reload('e60f1154', component.options)
    }
    module.hot.accept("./addcurrencyMapping.vue?vue&type=template&id=e60f1154&scoped=true&", function () {
      api.rerender('e60f1154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/currencyMapping/components/addcurrencyMapping.vue"
export default component.exports